import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import * as MutationTypes from './mutationTypes';

const forecastDemandListSuccess = (state, payload) => {
  state.forecastDemandList = payload;
};

const editForecastDemand = (state, payload) => {
  const { sliders, selectedServiceGuid } = payload;
  sliders.forEach((slider) => {
    state.forecastDemandList
      .find((demand) => demand.day === slider.day).sale_rates
      .find((saleRate) => saleRate.guid === slider.saleRateGuid).services
      .find(((service) => service.guid === selectedServiceGuid)).demand = slider.value;
  });
};

const resetPointOfSaleData = (state) => {
  state.forecastDemandList = [];
};

const eventOccurrenceListSuccess = (state, payload) => {
  state.eventOccurrenceList = payload;
};

export const mutations = {
  [MutationTypes.FORECAST_DEMAND_LIST_SUCCESS]: forecastDemandListSuccess,
  [MutationTypes.EDIT_FORECAST_DEMAND]: editForecastDemand,
  [RESET_POINT_OF_SALE_STATE]: resetPointOfSaleData,
  [MutationTypes.EVENT_OCCURRENCE_LIST_SUCCESS]: eventOccurrenceListSuccess,
};
